const assetBase = import.meta.env.BASE_URL;

export function assetUrl(path) {
  return `${assetBase}${path}`;
}
